import React from 'react';
import { useIntl } from 'react-intl';
import PropTypes from 'prop-types';

import Button from '../../../../../Button';

import styles from './index.styl';

const TestVideoButton = ({
  handleOpenTestCall,
  isJoinVirtualVisitByCode,
  showVisitBtn,
}) => {
  const { formatMessage } = useIntl();

  if (!showVisitBtn) {
    return null;
  }

  return (
    <div className={styles.testBtn}>
      <Button
        border
        color="accent"
        className="w-100"
        onClick={handleOpenTestCall}
        disabled={isJoinVirtualVisitByCode}
      >
        {formatMessage({ id: 'virtualVisit.test.check' })}
      </Button>
    </div>
  );
};

TestVideoButton.propTypes = {
  handleOpenTestCall: PropTypes.func.isRequired,
  isJoinVirtualVisitByCode: PropTypes.bool.isRequired,
  showVisitBtn: PropTypes.bool.isRequired,
};

export default TestVideoButton;



// WEBPACK FOOTER //
// ./src/components/Healthboard/Components/AppointmentCard/components/TestVideoButton/index.jsx